'use client'
import ReactDOM from 'react-dom'
import { useEffect, useState, ReactNode } from 'react'

export default function PopinPortal({ children }: { children: ReactNode }) {
	const [modalRoot, setModalRoot] = useState<HTMLElement | null>(null)

	useEffect(() => {
		setModalRoot(document.getElementById('modal-root'))
	}, [])

	if (!modalRoot) return null

	return ReactDOM.createPortal(children, modalRoot)
}
